/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Kind_PackagingInputs */

const vi_stocktake_kind_packaging = /** @type {(inputs: Stocktake_Kind_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bao bì`)
};

/**

* @param {Stocktake_Kind_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_kind_packaging = /** @type {((inputs?: Stocktake_Kind_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Kind_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_kind_packaging(inputs)
});